import { UseEvent } from "./index";

export default function UseAlert() {
  const event = UseEvent();
  const open = ({
    type="Result",
    cancelLabel = "დახურვა",
    message = "",
    containerStyle="",
    footer=true,
    ...props
  }) => {
    event.emit("lb-event", {
      type:type,
      cancelLabel,
      /*resultType:type,*/
      containerStyle:containerStyle,
      message,
      footer:footer,
      ...props, //actionLabel, onSuccess, onCancel
    });
  };
  return { open };
}
